import { POST } from "../APiHelper/API"


export const addMessageForPlayerSelection = (selection_conversation_id, message, onSuccess, onError) => {
    const data = {
        selection_conversation_id: selection_conversation_id,
        message: message
    }
    POST("/api/v1/conversations/add_message_for_selection", data, onSuccess, onError)
}